import { Company } from 'src/app/shared/libs/models/context.model';
import { DateRange } from './dateRange';
import { Status } from './status';
import { PaginationFilters } from './paginationFilters';
import { Brand } from './brand.model';

export class Photographer {
	company?: Company;
	id?: number;
	firstName?: string;
	lastName?: string;
	fullName?: string;
	brands?: Brand[];
	status?: Status;
	createdAt?: Date;
	contractStartDate?: Date;
	contractEndDate?: Date;
	email?: string;
	phoneNumber?: string;
	totalRevenue?: number;

	constructor(init?: Partial<Photographer>) {
		Object.assign(this, init);
	}
}

export class PhotographerFilters extends PaginationFilters {
	brands?: Brand[];
	contractDate?: DateRange;
	statuses?: Status[];
	textSearch?: string;

	constructor(init?: Partial<PhotographerFilters>) {
		super(init);
		Object.assign(this, init);
	}
}

export class PhotographerValidation {
	firstName: boolean = true;
	lastName: boolean = true;
	status: boolean = true;
	hired: boolean = true;
	brands: boolean = true;
	automaticRenewal: boolean = true;
	maxItems: boolean = true;

	constructor(init?: Partial<PhotographerValidation>) {
		Object.assign(this, init);
	}
}

// Backward-compatible alias for legacy usages.
export class PhotographerValitation extends PhotographerValidation {}

export enum PhotographerStatus {
	ON_TRIAL = 1,
	ACTIVE = 2,
	NOT_ACTIVE = 3,
	DISMISSED = 4
}
